import request from "@/utils/request";
import {ILoginFrom} from '@/types/types'


const loginUrl: string = "/api/Student/Login"
export function loginApi(data:ILoginFrom){
  return request({
    url:loginUrl,
    method:'post',
    data
  })
}

const uploadUrl = "/api/Upload"
export function uploadApi(data:any){
  return request({
    url:uploadUrl,
    method:'post',
    data
  })
}

const updateUrl = "/api/Student/Update"
export function updateApi(data:any){
  return request({
    url:updateUrl,
    method:'post',
    data
  })
}

const changePwdUrl = "/api/Student/AlterPwd"
export function changePwdApi(data:any){
  return request({
    url:changePwdUrl,
    method:'post',
    data
  })
}


const majorConfirmUrl = "/api/Student/Confirm"

export function majorConfirmApi(data:any){
  return request({
    url:majorConfirmUrl,
    method:'post',
    data
  })
}


const scopeSearchUrl = "/api/Student/ScopeSearch"

export function scopeSearchApi(data:any){
  return request({
    url:scopeSearchUrl,
    method:'post',
    data
  })
}

const payUrl = "/api/Student/OrderDetail"
export function payApi(data:any){
  return request({
    url:payUrl,
    method:'post',
    data
  })
}

const ticketUrl = "/api/Student/Ticket"
export function ticketApi(data:any){
  return request({
    url:ticketUrl,
    method:'post',
    data
  })
}


const userDetailUrl = "/api/Student/Detail"
export function userDetailApi(data:any){
  return request({
    url:userDetailUrl,
    method:'post',
    data
  })
}


const codeUrl = "/api/Web/SendMsg"
export function codeApi(data:any){
  return request({
    url:codeUrl,
    method:'post',
    data
  })
}


const registerUrl = "/api/Student/Register"
export function registerApi(data:any){
  return request({
    url:registerUrl,
    method:'post',
    data
  })
}

const forgetUrl = "/api/Student/Forget"
export function forgetApi(data:any){
  return request({
    url:forgetUrl,
    method:'post',
    data
  })
}


const scopePublishUrl = "/api/Student/ScopePublish"
export function scopePublishApi(data:any){
  return request({
    url:scopePublishUrl,
    method:'post',
    data
  })
}


export function unifiedSearchApi(data:any){
  return request({
    url:"/api/Student/UnifiedSearch",
    method:'post',
    data
  })
}